import integrationPicture from "../../assets/landingPageItems/integration.png";
const Integration = () => {
  return (
    <div id="integrations" className="py-8 md:py-12  text-center  bg-lightBlue ">
      <h2 className="text-4xl md:text-6xl font-audiowide text-white">
        Seamless <span className="text-lightGreen">Integrations</span>
      </h2>
      <p className="mt-4 md:mt-5 text-base md:text-lg text-gray-300">
        Your sales and transaction data shouldn't be a spreadsheet nightmare
      </p>
      <img
        src={integrationPicture}
        alt="Integration Illustration"
        className="w-full max-w-5xl mx-auto mt-8 select-none"
        draggable="false"
      />
    </div>
  );
};

export default Integration;
